/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */

import { SnippetBlock } from './SnippetBlock';

export default SnippetBlock;

/**
 * @deprecated Use `import { SnippetBlock } from '@atlaskit/smart-card/snippet-block'` instead.
 */
export { SnippetBlock } from './SnippetBlock';
